import { AuthenticationService } from './../../../services/authentication.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SaleTypeService } from './../../../services/sale-type.service';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuctionService, LotService } from '../../../services';
import { Auction } from '../../../models';
import { debounceTime } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import constants from '../../../utility/constants';
import { ModuleService } from '../../module.service';
import messages from '../../../utility/messages';
import { Observable, Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AdminAuctionList } from '../../../models/adminAuctionList';
import { AuctionTimeService } from '../../../services/auction-time.service';

@Component({
  selector: 'app-auction-list',
  templateUrl: './auction-list.component.html',
  styleUrls: ['./auction-list.component.css'],
})
export class AuctionListComponent implements OnInit {
  auctionStatusType: Array<{ value: number; text: string }> = [];
  auctionMode: string;

  auctionList: Array<AdminAuctionList> = [];

  saleType: any;
  //paging variables
  saleTypeId: number = null;
  status: number = 0;
  auctionStatus: boolean = false;
  auctionStatusId: number = 0;
  searchTerm: string = '';
  pageNumber: number = 1;
  pageSize: number = constants.admin.adminPageSize;
  sortBy: string = '';
  sortOrder: string = '';
  isPaginated: boolean = true;
  onlyActive: boolean = false;

  selectedFilter: string = 'Live';
  classToggled = false;
  mobileFilters = false;

  searchControl = new FormControl();
  searchMaxLength = constants.common.validations.searchMaxLength;

  role: any;
  startStop: any;
  upcomingAuctions: any;
  approveForm: FormGroup;
  approveCommonForm: FormGroup;
  modalRef: BsModalRef;
  submitLoader: boolean = false;
  loading: boolean = false;
  // total auction count
  totalAuctions: number;
  auctionId: any;
  //show view when data is loaded
  showView: boolean = false;
  auctionModel: AdminAuctionList;
  registrationId: any;
  pageReset: Boolean = false;
  disableCommonRegistrationButton: Boolean = true;
  currentUrl: string;
  websiteUrl: string = environment.websiteUrl;

  auctionStatuses = constants.common.auctionStatus;
  registrationFormat = constants.common.saletypeRegistrationFormat;
  displaySection = constants.common.displaySection;
  roles = constants.common.role;

  currentSelectedAuction: AdminAuctionList;
  isLoading: boolean = false;
  private subscriptions: Array<Subscription> = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private auctionService: AuctionService,
    private saleTypeService: SaleTypeService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private moduleService: ModuleService,
    private as: AuthenticationService,
    private lotService: LotService,
    private auctionTimeService: AuctionTimeService
  ) {}

  ngOnInit() {
    // this is to set the 1st tab alive
    this.role = this.as.currentUserValue()?.user?.role?.id;
    this.initializeSearchInputOnChangeListener();
    this.getSaleType();
    if (window.location.href.split('type=')[1] == 'live') {
      this.setQueryParam('live', 1);
      this.auctionMode = 'live';
    } else if (window.location.href.split('type=')[1] == 'upcoming') {
      this.setQueryParam('upcoming', 2);
      this.auctionMode = 'upcoming';
    } else if (window.location.href.split('type=')[1] == 'recent') {
      this.setQueryParam('recent', 4);
      this.auctionMode = 'recent';
    } else if (window.location.href.split('type=')[1] == 'pending') {
      this.setQueryParam('pending', 3);
      this.auctionMode = 'pending';
    } else {
      this.setQueryParam('live', 1);
      this.auctionMode = 'live';
    }

    const atypes = this.auctionService.getAuctionStatusType().subscribe(
      (res) => {
        this.auctionStatusType = res;
      },
      () => {}
    );
    this.subscriptions.push(atypes);
    this.route.queryParams.subscribe((params) => {
      if (params['type'] !== undefined) {
        let param: string = params['type'];
        this.auctionMode = param.toLowerCase();
      }
    });
    this.approveForm = new FormGroup({
      id: new FormControl(''),
      isPublic: new FormControl(false),
      isRegistrationActive: new FormControl(false),
      registrationSyncWithAuctionId: new FormControl(''),
    });
    this.approveCommonForm = new FormGroup({
      auctionId: new FormControl(''),
      syncWithAuctionId: new FormControl(''),
    });

    // calling list
    this.getListing();
    this.currentUrl = this.router.url;
  }

  goToReportSection(id, auctionMode) {
    this.router.navigate(['/admin/dashboard/reports'], {
      queryParams: { id: id, auctionMode: auctionMode },
    });
  }

  openLink(url) {
    window.open(url, '_blank');
  }

  openLotsLink(url) {
    window.open(url + '#check', '_blank');
  }

  resetSearch() {
    this.searchControl.reset();
    this.getListing();
  }

  changeSearchValue(val: Observable<string>) {
    const vals = val.subscribe((value) => {
      this.searchTerm = value;
      this.pageNumber = 1;
      this.getListing();
    });
    this.subscriptions.push(vals);
  }

  checkApproveAuction(): boolean {
    return this.moduleService.userHas(constants.admin.modules.approveAuction);
  }

  checkCreateAuction(): boolean {
    return this.moduleService.userHas(constants.admin.modules.createNewAuction);
  }

  getSaleType() {
    const stypes = this.saleTypeService.getSaletypeForDropDown().subscribe((data) => {
      this.saleType = data;
    });
    this.subscriptions.push(stypes);
  }
  onSaleTypeFilter(saleTypeId) {
    this.saleTypeId = saleTypeId;
    this.pageNumber = 1;
    this.getListing();
  }
  private initializeSearchInputOnChangeListener() {
    this.searchControl.valueChanges
      .pipe(debounceTime(1200))
      .subscribe((value: any) => {
        this.searchTerm = value;
        this.pageNumber = 1;
        this.getListing();
      });
  }
  // set the auction mode
  setQueryParam(auctionType: string, aucStatusId?: number) {
    this.pageNumber = 1;
    this.pageReset = true;
    this.router.navigate(['./'], {
      relativeTo: this.route,
      queryParams: { type: auctionType },
    });

    this.auctionStatusId = aucStatusId;
    this.selectedFilter = auctionType;
    this.auctionMode = auctionType;
    this.getListing();
  }

  // paging info
  paging() {
    if (this.searchTerm == null || this.searchTerm == undefined) {
      this.searchTerm = '';
    }
    let model = {
      saleTypeId: this.saleTypeId,
      status: this.status,
      auctionStatusId: this.auctionStatusId,
      searchTerm: this.searchTerm,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortBy: this.sortBy,
      sortOrder: this.sortOrder,
      isPaginated: this.isPaginated,
      onlyActive: this.onlyActive,
    };
    return model;
  }
  onPageChange(paging: number) {
    this.pageNumber = paging;
    this.pageReset = false;
    this.getListing();
  }
  // live listing section
  getListing() {
    this.showView = false;
    this.isLoading = true;
    const gaucs = this.auctionService.getAuctions(this.paging()).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.auctionList = res.data;
        this.totalAuctions = res.totalCount;
        if (this.totalAuctions > this.pageSize) {
          this.showView = true;
        } else {
          this.showView = false;
        }
      },
      () => {
        this.isLoading = false;
        this.showView = true;
      }
    );
    this.subscriptions.push(gaucs);
  }

  checkLotClosing(lotCloseStartTime: string, lotCloseEndTime: string): boolean {
    var result = this.auctionTimeService.isLotClosing(
      lotCloseStartTime,
      lotCloseEndTime
    );
    return result;
  }

  openDeActivateAuction(
    template2: TemplateRef<any>,
    actionModel: AdminAuctionList,
    status: boolean
  ) {
    this.modalRef = this.modalService.show(
      template2,
      Object.assign({
        backdrop: 'static',
        keyboard: false,
        class: 'custom-popup activate-modal modal-dialog modal-dialog-centered',
      })
    );
    this.auctionModel = actionModel;
    this.auctionStatus = status;
  }

  importAuctionModal(
    importAuction: TemplateRef<any>,
    auction: AdminAuctionList
  ) {
    this.auctionModel = auction;
    this.modalRef = this.modalService.show(
      importAuction,
      Object.assign({
        class: 'custom-popup modal-dialog modal-dialog-centered importAuction',
      })
    );
  }

  importAuctionUserModal(
    importAuctionUser: TemplateRef<any>,
    auction: AdminAuctionList
  ) {
    this.auctionModel = auction;
    this.modalRef = this.modalService.show(
      importAuctionUser,
      Object.assign({
        class:
          'custom-popup modal-dialog modal-dialog-centered importAuctionUser',
      })
    );
  }

  deActivateAuction(auctionModel: AdminAuctionList) {
    this.submitLoader = true;
    const statuschange = this.auctionService
      .auctionChangeStatus({ id: auctionModel.id })
      .subscribe(() => {
        this.submitLoader = false;
        this.modalService.hide();
        if (this.auctionStatus == true) {
          this.toastr.success(
            messages.auctionListing.deActivateAuction,
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
          this.auctionStatus = !this.auctionStatus;
        } else {
          this.toastr.success(
            messages.auctionListing.activateAuction,
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
          this.auctionStatus = !this.auctionStatus;
        }
        this.getListing();
      });
      this.subscriptions.push(statuschange);
  }
  openDeleteAuction(template: TemplateRef<any>, actionModel: AdminAuctionList) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({
        backdrop: 'static',
        keyboard: false,
        class: 'custom-popup activate-modal modal-dialog modal-dialog-centered',
      })
    );
    this.auctionModel = actionModel;
  }

  openFeaturedPastModal(
    template: TemplateRef<any>,
    actionModel: AdminAuctionList
  ) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({
        backdrop: 'static',
        keyboard: false,
        class: 'custom-popup activate-modal modal-dialog modal-dialog-centered',
      })
    );
    this.auctionModel = actionModel;
  }

  openUnarchiveModal(
    template: TemplateRef<any>,
    actionModel: AdminAuctionList
  ) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({
        backdrop: 'static',
        keyboard: false,
        class: 'custom-popup activate-modal modal-dialog modal-dialog-centered',
      })
    );
    this.auctionModel = actionModel;
  }

  unarchiveAuction() {
    this.submitLoader = true;
    const uacution = this.auctionService.unarchiveAuction(this.auctionModel.id).subscribe(
      () => {
        this.pageReset = true;
        this.submitLoader = false;
        this.getListing();
        this.toastr.success(
          `Auction ${
            this.auctionModel.isArchived ? 'Unarchive' : 'Archive'
          } successfully`,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.closeModal();
      },
      (err) => {
        this.submitLoader = false;
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
        this.closeModal();
      }
    );
    this.subscriptions.push(uacution);
  }

  updateFeaturedPast() {
    this.submitLoader = true;
    const auction = this.auctionService.changeFeaturedPast(this.auctionModel.id).subscribe(
      () => {
        this.pageReset = true;
        this.submitLoader = false;
        this.getListing();
        this.toastr.success(
          `Auction ${
            this.auctionModel.isArchived ? 'Unarchive' : 'Archive'
          } successfully`,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.closeModal();
      },
      (err) => {
        this.submitLoader = false;
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
        this.closeModal();
      }
    );
    this.subscriptions.push(auction);
  }

  unpublishCatalog() {
    this.submitLoader = true;
    const ulots = this.lotService.unpublishLots(this.auctionModel.id).subscribe(
      () => {
        this.pageReset = true;
        this.submitLoader = false;
        this.getListing();
        this.toastr.success(
          'Lot Catalog Unpublished successfully',
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.closeModal();
      },
      (err) => {
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
        this.closeModal();
      }
    );
    this.subscriptions.push(ulots);
  }

  deleteAuction(auctionModel: AdminAuctionList) {
    this.submitLoader = true;
    const audelete = this.auctionService
      .auctionDelete({ auctionId: auctionModel.id })
      .subscribe(() => {
        this.pageReset = true;
        this.submitLoader = false;
        this.getListing();
        this.toastr.success(
          messages.auctionListing.deleteAuction,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.modalService.hide();
      });
      this.subscriptions.push(audelete);
  }
  getUpcomingAuctions(id: number) {
    const upauctions = this.auctionService.getUpcomingAuctions(id,true).subscribe(
      (res) => {
        this.upcomingAuctions = res;
      },
      () => {}
    );
    this.subscriptions.push(upauctions);
  }
  openStatusAuction(
    template: TemplateRef<any>,
    actionModel: Auction,
    status: number
  ) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({
        backdrop: 'static',
        keyboard: false,
        class: 'custom-popup activate-modal modal-dialog modal-dialog-centered',
      })
    );
    this.startStop = status;
    this.registrationId = actionModel;
  }
  approveAuction() {
    this.submitLoader = true;
    this.approveForm.get('id').setValue(this.auctionId);

    const auapprove = this.auctionService
      .auctionApprove(this.approveForm.getRawValue())
      .subscribe(
        () => {
          this.submitLoader = false;
          this.getListing();
          this.approveForm.reset();
          this.toastr.success(
            messages.auctionListing.approveAuction,
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
          this.modalRef.hide();
        },
        (err) => {
          this.submitLoader = false;
          this.toastr.error(
            err,
            constants.common.toast.errorTitle,
            constants.common.toast.config
          );
        }
      );
      this.subscriptions.push(auapprove);
  }
  approveCommonAuction() {
    this.submitLoader = true;
    this.approveCommonForm.get('auctionId').setValue(this.auctionId);
    const sregister = this.auctionService
      .syncRegistrationWithOtherAuction(this.approveCommonForm.getRawValue())
      .subscribe(() => {
        this.submitLoader = false;
        this.getListing();
        this.approveCommonForm.reset();
        this.toastr.success(
          messages.auctionListing.approveAuction,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.modalRef.hide();
      });
      this.subscriptions.push(sregister);
  }
  openApproveAuction(
    template: TemplateRef<any>,
    currentAuction: AdminAuctionList
  ) {
    this.currentSelectedAuction = currentAuction;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({
        backdrop: 'static',
        keyboard: false,
        class:
          'custom-popup activate-modal activate-lmodal text-left modal-dialog modal-dialog-centered approve-auction',
      })
    );
    this.auctionId = currentAuction.id;
    this.getUpcomingAuctions(this.auctionId);
  }
  auctionStartRegistration(id) {
    this.submitLoader = true;
    const auregister = this.auctionService.auctionStartRegistration({ id: id }).subscribe(
      () => {
        this.getListing();
        this.submitLoader = false;
        this.modalService.hide();
        this.toastr.success(
          messages.auctionListing.auctionStartRegistration,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
      },
      (err) => {
        this.getListing();
        this.submitLoader = false;
        this.modalService.hide();
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      }
    );
    this.subscriptions.push(auregister);
  }
  closeModal() {
    this.modalService.hide();
    this.approveForm.reset();
  }
  auctionStopRegistration(id) {
    this.submitLoader = true;
    const stopregister = this.auctionService.auctionStopRegistration({ id: id }).subscribe(
      () => {
        this.getListing();
        this.submitLoader = false;
        this.modalService.hide();
        this.toastr.success(
          messages.auctionListing.auctionStopRegistration,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
      },
      (err) => {
        this.getListing();
        this.submitLoader = false;
        this.closeModal();
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      }
    );
    this.subscriptions.push(stopregister);
  }
  markItFeatured(id) {
    const markfeature = this.auctionService.markItFeatured(id).subscribe((res) => {
      this.getListing();
      this.toastr.success(
        res
          ? messages.auctionListing.markItFeatured
          : messages.auctionListing.markItUnFeatured,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
    });
    this.subscriptions.push(markfeature);
  }
  markAsSold(id) {
    const msold = this.auctionService.markAsSold({ id: id }).subscribe(() => {
      this.getListing();
      this.toastr.success(
        messages.auctionListing.markAsSold,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
    });
    this.subscriptions.push(msold);
  }
  stopSyncRegistrationWithOtherAuction(id) {
    const sauctions = this.auctionService
      .stopSyncRegistrationWithOtherAuction({ id: id })
      .subscribe(() => {
        this.getListing();
        this.toastr.success(
          messages.auctionListing.stopSyncRegistrationWithOtherAuction,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
      });
      this.subscriptions.push(sauctions);
  }
  syncRegistrationWithOtherAuction() {
    this.isLoading = true;
    this.approveCommonForm.patchValue({ auctionId: this.auctionId });
    this.approveCommonForm.patchValue({
      syncWithAuctionId: this.approveCommonForm.get('syncWithAuctionId').value,
    });
    const otherAuction = this.auctionService
      .syncRegistrationWithOtherAuction(this.approveCommonForm.getRawValue())
      .subscribe(
        () => {
          this.submitLoader = false;
          this.getListing();
          this.approveCommonForm.reset();
          this.isLoading = false;
          this.modalRef.hide();
          this.toastr.success(
            messages.auctionListing.startSyncRegistrationWithOtherAuction,
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
        },
        (error) => {
          this.toastr.error(
            error,
            constants.common.toast.errorTitle,
            constants.common.toast.config
          );
          this.isLoading = false;
        }
      );
      this.subscriptions.push(otherAuction);
  }

  upcomingAuctionChange(value: string) {
    this.disableCommonRegistrationButton = Number(value) > 0 ? false : true;
  }

  goToUsers(auctionId) {
    this.router.navigate(['./', auctionId, 'users'], {
      relativeTo: this.route,
      queryParams: {
        returnTo: this.router.url,
      },
    });
  }

  goToBidders(auctionId) {
    this.router.navigate(['./', auctionId, 'bids', 'bidder'], {
      relativeTo: this.route,
      queryParams: {
        returnTo: this.router.url,
      },
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
